<div class="cmn-flex row align-start gutters">
  <mat-icon class="header-icon">vpn_key</mat-icon>
  <div class="cmn-flex flex column">
    <h2>Copy Your Key</h2>
    <div>Make sure to copy your API Key. This is the only time we will display it.</div>
  </div>
</div>
<div class="key-container spaced-top spaced-bottom padded cmn-border">
  {{ data.jwt }}
</div>

<div class="cmn-flex row justify-between gutters cmn-border-top padded-top">
  <button mat-button mat-dialog-close class="flex camelCase">Close</button>
  <button mat-raised-button color="accent" (click)="copyKey()" class="flex camelCase">Copy</button>
</div>
